function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { useMemo } from "react";
import useNavigationList from "./useNavigationList";
import useNavigationListItem from "./useNavigationListItem";
const StyledDiv = styled("div")`
  display: flex;
  flex-direction: column;
`;
function ListItem(props) {
    const { renderItem , object , index  } = props;
    const options = useMemo(()=>({
            object,
            index
        }), [
        object,
        index
    ]);
    const { helpers , navProps  } = useNavigationListItem(object.nodeId, options);
    const { ref  } = navProps, rest = _objectWithoutProperties(navProps, [
        "ref"
    ]);
    return /*#__PURE__*/ _jsx("div", _objectSpread({
        ref: ref
    }, rest, {
        children: renderItem(object, index, helpers)
    }));
}
/*
 * Example of how to use the above hooks; they can also be
 * used directly if you prefer. Up to you.
 */ export default function NavigationList(props) {
    const { items , listId , renderItem , multiselect , actions , performSingularAction , actionWasPerformed , groupContainer =false , prepend , append ,  } = props;
    const options = useMemo(()=>({
            multiselect,
            actions,
            performSingularAction,
            actionWasPerformed,
            groupContainer
        }), [
        multiselect,
        actions,
        performSingularAction,
        actionWasPerformed,
        groupContainer, 
    ]);
    const { navProps , Provider  } = useNavigationList(listId, options);
    return /*#__PURE__*/ _jsx(Provider, {
        children: /*#__PURE__*/ _jsxs(StyledDiv, _objectSpread({}, navProps, {
            children: [
                prepend,
                items.map((item, idx)=>/*#__PURE__*/ _jsx(ListItem, {
                        renderItem: renderItem,
                        object: item,
                        index: idx
                    }, item.nodeId)),
                append
            ]
        }))
    });
};
